import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export default {
  ts: dayjs().utcOffset(120),
  eventTs: 0,
  eventsLoading: true,
  allEvents: [],
  events: [],
  pastEvents: [],
  eventCount: 0
};
